import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import './searchInput.scss'
import debounce from 'lodash/debounce'
import ButtonBase from '../ButtonBase'
import CloseIcon from '../../assets/svgs/close-thick.svg'
import SearchIcon from '../../assets/svgs/search.svg'

const searchIntervalTime = 200

const SearchInput = ({ className, alwaysOpen, setFilter, placeholder, initialValue }) => {
  const input = useRef(null)
  const [isOpen, setIsOpen] = useState(!!initialValue)
  const [value, setValue] = useState(initialValue)
  const throttledSetFilter = debounce((value) => setFilter(value), searchIntervalTime)

  const open = () => {
    setIsOpen(true)
    setTimeout(() => {
      input.current.focus()
    })
  }

  const close = () => {
    setIsOpen(false)
    setValue('')
    throttledSetFilter('')
  }

  const handleBlur = () => {
    if (!value) close()
  }

  const handleChange = (event) => {
    const currValue = event.target.value
    throttledSetFilter(currValue)
    setValue(currValue)
  }

  const handleKeyDown = (event) => {
    const currValue = event.target.value
    if (event.key === 'Enter') {
      throttledSetFilter(currValue)
    }
  }

  return (<div
    className={`Suc-search-input ${isOpen || alwaysOpen ? 'Suc-opened' : ''} ${className}`}>
    <ButtonBase className="Suc-open-input" disabled={alwaysOpen} onClick={!alwaysOpen
      ? open
      : () => {
        }}><SearchIcon/></ButtonBase>
    <input placeholder={placeholder || 'Search'}
           onBlur={() => handleBlur()}
           ref={input}
           value={value}
           onChange={handleChange}
           onKeyDown={handleKeyDown}/>
    {alwaysOpen ? null : <ButtonBase className="Suc-close-input" onClick={close}><CloseIcon/></ButtonBase>}
  </div>)
}

SearchInput.propTypes = {
  /** Should Input be always open */
  alwaysOpen: PropTypes.bool,
  /** custom classname */
  className: PropTypes.string,
  /** filter function to update the state of list */
  setFilter: PropTypes.func,
  /** search input placeholder value */
  placeholder: PropTypes.string,
  /** intial value - if passed from app state */
  initialValue: PropTypes.string
}

SearchInput.defaultProps = {
  className: '',
  alwaysOpen: false,
  initialValue: ''
}

export default SearchInput
